import { UserPlus } from "lucide-react";
import { useForm } from "react-hook-form";
import Button from "../../components/ui/Button";
import Dialog from "../../components/ui/Dialog";
import type { AuthRole } from "../../types/auth";

type InviteForm = {
  email: string;
  role: AuthRole;
};

interface Props {
  onSubmit: (values: InviteForm) => Promise<void>;
  onClose: () => void;
}

export default ({ onSubmit, onClose }: Props) => {
  const inviteForm = useForm<InviteForm>({
    defaultValues: { email: "", role: "team" },
  });

  const handleSubmit = inviteForm.handleSubmit(async values => {
    await onSubmit(values);
  });

  return (
    <Dialog title="Invite member" subtitle="Send a role-based invite email to a new team member." onClose={onClose} TitleIcon={UserPlus}>
      <form onSubmit={event => void handleSubmit(event)} className="space-y-4">
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-slate-500">Email address</label>
          <input
            {...inviteForm.register("email", { required: true })}
            type="email"
            placeholder="colleague@company.com"
            className="h-10 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-900 outline-none transition-colors placeholder:text-slate-400 focus:border-indigo-500 focus:bg-white"
          />
        </div>
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-slate-500">Role</label>
          <select
            {...inviteForm.register("role", { required: true })}
            className="h-10 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 pr-10 text-sm outline-none transition-colors focus:border-indigo-500 focus:bg-white"
          >
            <option value="team">Team Member</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div className="flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={inviteForm.formState.isSubmitting}>
            <UserPlus className="h-4 w-4" />
            {inviteForm.formState.isSubmitting ? "Sending..." : "Send invite"}
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
